/* eslint-disable */
import {debounce} from '~/helpers/utils';

const filteredEvent = new CustomEvent('filteredResults:rendered');
const updateSwatchesEvent = new CustomEvent('swatchesUpdate:needed');

class FacetFiltersForm extends HTMLElement {
    constructor() {
      super();
      this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 500);

      const facetForm = this.querySelector('form');
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

      this.hydrateFilters = this.hydrateFilters.bind(this);
      this.hydrateFilters();
    }

    static setListeners() {
      const onHistoryChange = (event) => {
        const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
        if (searchParams === FacetFiltersForm.searchParamsPrev) return;
        FacetFiltersForm.renderPage(searchParams, null, false);
      }
      window.addEventListener('popstate', onHistoryChange);
    }

    static toggleActiveFacets(disable = true) {
      document.querySelectorAll('.filter-group__list-item').forEach((element) => {
        element.classList.toggle('disabled', disable);
      });
    }

    static renderPage(searchParams, event, updateURLHash = true) {
      FacetFiltersForm.searchParamsPrev = searchParams;
      const sections = FacetFiltersForm.getSections();
      const countContainer = document.getElementById('ProductCount');
      document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('is-loading');
      if (countContainer){
        countContainer.classList.add('loading');
      }

      sections.forEach((section) => {
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        const filterDataUrl = element => element.url === url;

        FacetFiltersForm.filterData.some(filterDataUrl) ?
          FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
          FacetFiltersForm.renderSectionFromFetch(url, event);
      });

      if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    }

    static renderSectionFromFetch(url, event) {
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
          FacetFiltersForm.renderFilters(html, event);
          FacetFiltersForm.renderProductGridContainer(html);
        });
    }

    static renderSectionFromCache(filterDataUrl, event) {
      const html = FacetFiltersForm.filterData.find(filterDataUrl).html;

      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
    }

    static renderProductGridContainer(html) {
      document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

      window.dispatchEvent(filteredEvent);
      window.dispatchEvent(updateSwatchesEvent);
      const event = new CustomEvent('Alessi:loadMoreEnd');
      document.dispatchEvent(event);
    }



    static renderFilters(html, event) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

      const facetDetailsElements =
        parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter');
      const matchesIndex = (element) => {
        const jsFilter = event ? event.target.closest('.js-filter') : undefined;
        return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
      }

      const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
      const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

      facetsToRender.forEach((element) => {
        document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
      });

      FacetFiltersForm.renderActiveFacets(parsedHTML);
      FacetFiltersForm.renderAdditionalElements(parsedHTML);
    }

    static renderActiveFacets(html) {
      const activeFacetElementSelectors = ['.active-filters'];

      activeFacetElementSelectors.forEach((selector) => {
        const activeFacetsElement = html.querySelector(selector);
        if (!activeFacetsElement) return;
        document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
      })

      FacetFiltersForm.toggleActiveFacets(false);
    }

    static renderAdditionalElements(html) {
      const mobileElementSelectors = [ '.sorting', '.facets__count', '.filter-drawer__title', '.filter-drawer__footer', '.typology-filters'];

      mobileElementSelectors.forEach((selector) => {
        if (!html.querySelector(selector)) return;
        document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
      });


    }

    static updateURLHash(searchParams) {
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }

    static getSections() {
      return [
        {
          section: document.getElementById('ProductGridContainer').dataset.id,
        }
      ]
    }

    async hydrateFilters(){
      const _this = this;
      const swatchEndpoint = _this.getAttribute('data-swatch-endpoint');
      if(swatchEndpoint) {
        try {
          const response = await fetch(window.location.origin + swatchEndpoint + '?view=api-swatches');
          const responseBody = await response.text();
          const responseHtml =  new DOMParser().parseFromString(responseBody, 'text/html');
          const swatchesElement = responseHtml.querySelector('body');
          const swatchesData = JSON.parse(swatchesElement.innerText);
          const swatchTemplateDefault = document.querySelector('[data-swatch-template-type="default"]');
          const swatchTemplate3Color = document.querySelector('[data-swatch-template-type="hex-3"]');
          const swatchTemplate2Color = document.querySelector('[data-swatch-template-type="hex-3"]');

          if(swatchesData && swatchTemplateDefault && swatchTemplate3Color && swatchTemplate2Color) {

            swatchesData.map(swatchData => {
              const swatchId = swatchData.id;
              const swatchWrapper = document.querySelector('[data-swatch-id="'+ swatchId +'"]');
              let swatchEl;

              if(swatchWrapper) {
                swatchEl = swatchWrapper.querySelector('.swatch__button');

                if(swatchData.img) {
                  swatchWrapper.innerHTML = swatchTemplateDefault.innerHTML;
                  swatchEl = swatchWrapper.querySelector('.swatch__button');
                  swatchEl.style.background = `url(${swatchData.img})`;
                  swatchEl.style.backgroundSize = 'cover';
                }

                if(swatchData.hex && swatchData.hex.length) {
                  switch (swatchData.hex.length) {
                    case 3:
                      swatchWrapper.innerHTML = swatchTemplate3Color.innerHTML;
                      swatchEl = swatchWrapper.querySelector('.swatch__button');
                      const pie1 = swatchEl3.querySelector('.pie-1');
                      const pie2 = swatchEl3.querySelector('.pie-2');

                      if(pie1){
                        pie1.style.backgroundColor = swatchData.hex[1];
                      }

                      if(pie2) {
                        pie2.style.backgroundColor = swatchData.hex[2];
                      }
                      break;
                    case 2:
                      swatchWrapper.innerHTML = swatchTemplate2Color.innerHTML;
                      swatchEl = swatchWrapper.querySelector('.swatch__button');
                      const rightColor = swatchEl2.querySelector('.right-color');

                      if(rightColor) {
                        rightColor.style.backgroundColor = swatchData.hex[1];
                      }
                      break;
                    default:
                      swatchWrapper.innerHTML = swatchTemplateDefault.innerHTML;
                      swatchEl = swatchWrapper.querySelector('.swatch__button');
                  }

                  swatchEl.style.background = swatchData.hex[0];
                }
              }

            });
          }
        } catch(e) {
          console.log('ERROR WHILE FETCHING SWATCHES DATA: ', e);
        }
      }
    }

    createSearchParams(form) {
      const formData = new FormData(form);

      const sliderMin = form.querySelector('[name="filter.v.price.gte"]');
      if(sliderMin && sliderMin.value == sliderMin.min) {
        formData.delete('filter.v.price.gte');
      }

      const sliderMax = form.querySelector('[name="filter.v.price.lte"]');
      if(sliderMax && sliderMax.value == `${parseInt(sliderMin.max)}`) {
        formData.delete('filter.v.price.lte');
      }

      return new URLSearchParams(formData).toString();
    }

    onSubmitForm(searchParams, event) {
      FacetFiltersForm.renderPage(searchParams, event);
    }

    onSubmitHandler(event) {
      event.preventDefault();
      const allForms = document.querySelectorAll('facet-filters-form form');
      const filters = [];

      allForms.forEach((form) => {
        filters.push(this.createSearchParams(form));
      });

      const combinedFilters = filters.join('&');
      this.onSubmitForm(combinedFilters, event);
    }



    onActiveFilterClick(event) {
      event.preventDefault();
      FacetFiltersForm.toggleActiveFacets();
      const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
      FacetFiltersForm.renderPage(url);
    }
  }

  FacetFiltersForm.filterData = [];
  FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
  FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
  customElements.define('facet-filters-form', FacetFiltersForm);
  FacetFiltersForm.setListeners();

  class PriceRange extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll('input[data-filter-master]')
        .forEach(element => {
          /* element.addEventListener('change', this.onRangeChange.bind(this)) */
          element.addEventListener('input', this.onRangeInput.bind(this))
      });

      this.querySelectorAll('input[data-filter-slave]')
      .forEach(element => {
        element.addEventListener('input', this.onRangeChange.bind(this))
        element.addEventListener('change', this.onInputChange.bind(this))
      });
      /* this.setMinAndMaxValues(); */
    }

    onRangeChange(event) {
      this.adjustToValidValues(event.currentTarget);
      this.syncInputs(event.target);
      /* this.setMinAndMaxValues(); */
      this.adjustRangeValues();
    }

    onRangeInput(event) {
      this.syncInputs(event.currentTarget);
      this.adjustRangeValues();
    }

    onInputChange(event){
      const inputLink = event.target.getAttribute('data-filter-link');
      let inputSelector = `[data-filter-master][data-filter-link="${inputLink}"]`;
      const linkedInput = this.querySelector(inputSelector);

      const e = new CustomEvent('input');
      linkedInput.dispatchEvent(e);
    }

    adjustRangeValues() {
      const min = this.querySelector('input.range-min');
      const max = this.querySelector('input.range-max');
      const minLabel = this.querySelector('[data-price-range-input-from]');
      const maxLabel = this.querySelector('[data-price-range-input-to]');

      minLabel.innerHTML = formatMoney(parseInt(min.value) * 100, theme.moneyFormat);
      maxLabel.innerHTML = formatMoney(parseInt(max.value) * 100, theme.moneyFormat);
    }

    syncInputs(input) {
      const isMaster = input.hasAttribute('data-filter-master');
      const inputLink = input.getAttribute('data-filter-link');
      let inputSelector = `${isMaster ? '[data-filter-slave]' : '[data-filter-master]'}[data-filter-link="${inputLink}"]`
      const linkedInput = this.querySelector(inputSelector);
      linkedInput.value = input.value !== '' ? input.value : 0;
    }

    adjustToValidValues(input) {
      const value = Number(input.value);
      const min = Number(input.getAttribute('min'));
      const max = Number(input.getAttribute('max'));

      if (value < min) input.value = min;
      if (value > max) input.value = max;
    }
  }

  customElements.define('price-range', PriceRange);


  class FacetRemove extends HTMLElement {
    constructor() {
      super();
      const facetLink = this.querySelector('a');
      facetLink.setAttribute('role', 'button');
      facetLink.addEventListener('click', this.closeFilter.bind(this));
      facetLink.addEventListener('keyup', (event) => {
        event.preventDefault();
        if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
      });
    }

    closeFilter(event) {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    }
  }

  customElements.define('facet-remove', FacetRemove);
